import { HomeComponent } from './modules/home/home.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/auth/_services/auth.guard';
import { AuthCheckOnlyLogin } from './core/auth/_services/auth.check.login';
import { InitPasswordFirstComponent } from './modules/init-password-first/init-password-first.component';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./core/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./core/errors/errors.module').then((m) => m.ErrorsModule),
  },
  {
    path: 'init-password',
    component: InitPasswordFirstComponent
  },
  {
    path: 'main',
    loadChildren: () =>
      import('./pages/layout.module').then((m) => m.LayoutModule),
  },
 
  {
    path: '',
    component: HomeComponent
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
